import styled from 'styled-components';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useEnvelope } from '../../../hooks/useEnvelope';
import { useMutation, useQueryClient } from 'react-query';
import { getFile, getFileForAdhoc } from '../../../services/file';
import { FileContext } from '../../../context/FileContext';

const StyledDropdownForPdfSwitch = styled(Dropdown)`
  width: 167px;
`;

const PdfSwitchContainer = styled.div`
  position: relative;
  z-index: 100;
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const PdfSwitchDropdown = ({ t }) => {
  const { envelopeId } = useContext(FileContext);
  const {
    envelopeData,
    setActiveFileId,
    setActiveFileData,
    setFileTopAndBottom,
    scrollToTop,
    isAdhoc,
  } = useEnvelope();
  const params = useParams();
  const fileId = envelopeData?.activeFileId || params.id;

  const queryClient = useQueryClient();

  const { mutate: getActiveFileById } = useMutation(({ id, itemId }) =>
    getFile(id, itemId),
  );

  // const {} = useQuery();

  const { mutate: getActiveFileByIdForAdhoc } = useMutation(getFileForAdhoc);

  const pdfOptions = useMemo(() => {
    return (
      envelopeData?.attachedFiles?.map((x) => {
        return {
          value: x._id || x.assetId,
          label: x.file_name || x.fileName,
        };
      }) || []
    );
  }, [envelopeData]);

  const selectedPDF = () => {
    return pdfOptions.find((x) => x.value == fileId);
  };

  const selectedPDFIndex = () => {
    return pdfOptions.findIndex((x) => x.value == fileId) + 1;
  };

  const handleChange = (e) => {
    if (isAdhoc) {
      getActiveFileByIdForAdhoc(
        { envelopeId, assetId: e.value },
        {
          onSuccess: (res) => {
            const fileData = {
              _id: res?.mondayFileDetails?.[0]?.id,
              file: res?.base64File,
              file_name: res?.mondayFileDetails?.[0]?.name,
              board_id: res?.envelopeDetails?.board_id,
              account_id: res?.envelopeDetails?.account_id,
              fields: res?.fileDetails?.fields || [],
              fileType: res?.mondayFileDetails?.[0]?.file_extension?.replace(
                '.',
                '',
              ),
              pages_added_by_users: [],
            };
            setActiveFileId(e.value);
            setActiveFileData(fileData, true);
            setFileTopAndBottom(envelopeData.attachedFiles, e.value);
            scrollToTop();
          },
        },
      );
    } else {
      getActiveFileById(
        { id: e.value, itemId: params.itemId },
        {
          onSuccess: (res) => {
            setActiveFileId(e.value);
            setActiveFileData(res.data);
            setFileTopAndBottom(envelopeData.attachedFiles, e.value);
            scrollToTop();
            queryClient.setQueryData(['get-file', e.value], (oldData) => {
              return oldData || res;
            });
          },
        },
      );
    }
  };

  return (
    <PdfSwitchContainer>
      {pdfOptions.length > 1 ? (
        <>
          Editing file {selectedPDFIndex()} of {pdfOptions.length}
          <StyledDropdownForPdfSwitch
            clearable={false}
            searchable={false}
            options={pdfOptions}
            value={selectedPDF()}
            placeholder={t('PDF Name')}
            size={Dropdown.size.SMALL}
            className="dropdown-stories-styles_with-chips"
            onChange={handleChange}
          />
        </>
      ) : null}
    </PdfSwitchContainer>
  );
};

export default PdfSwitchDropdown;
